import { render, staticRenderFns } from "./MediaCardView.vue?vue&type=template&id=42587686&scoped=true"
import script from "./MediaCardView.vue?vue&type=script&lang=ts"
export * from "./MediaCardView.vue?vue&type=script&lang=ts"
import style0 from "./MediaCardView.vue?vue&type=style&index=0&id=42587686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42587686",
  null
  
)

export default component.exports